<nz-drawer [nzBodyStyle]="{ overflow: 'auto', display: 'flex', 'flex-direction': 'column', gap: '20px' }"
           [nzMaskClosable]="false" [nzVisible]="showImportDrawer()" nzTitle="Import {{title()}} from CSV file"
           [nzFooter]="footerTpl" (nzOnClose)="requestCloseImportDrawer.emit()">

  <ng-container *nzDrawerContent>
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <label style="font-weight: bold;">Select the software you are migrating from:</label>
      <nz-select [formControl]="selectedSourceControl" [nzPlaceHolder]="'Select Source'" nzShowSearch
                 [nzOptions]="importSourcesOptions()">
      </nz-select>
    </div>
    <span>or use the QNE CSV Import Template:</span>
    <div class="mt-sm">
      <a rel="noopener"
         [href]="sampleDownloadUrl()"
         target="_blank" style="color: #007bff;">
        Download Sample
      </a>
    </div>
    <ng-content></ng-content>
    <nz-divider></nz-divider>
    <div style="padding: 0 16px;">
      <h4 style="margin-bottom: 12px; color: #f7a600;"><b>Quick N’ Easy Tips</b>:</h4>
      <ul style="list-style-type: disc; padding-left: 16px; margin-top: 8px; font-size: 14px; color: #333;">
        <li>
          Select the migrating software from the dropdown and follow our step-by-step guides for exporting COA from
          SQL Accounting, UBS, Autocount, or Xero.
          <a target="_blank" href="https://support.qne.com.ph/a/solutions/articles/35000270081"
             style="color: #007bff; text-decoration: underline;">Click Here to Know More</a>.
        </li>
        <li>
          If your software isn’t listed or you prefer to create your own template, download the QNE CSV format.
        </li>
        <li>
          Don’t forget to check for Errors. Remove blank rows or invalid data to avoid upload issues.
        </li>
      </ul>
    </div>
  </ng-container>

  <ng-template #footerTpl>
    <div class="float-right">
      <button type="button" nz-button (click)="requestCloseImportDrawer.emit()">Cancel</button>
      <button type="button" nz-button nzType="primary" (click)="requestImportData.emit()">Import</button>
    </div>
  </ng-template>
</nz-drawer>
